export default __webpack_public_path__ + "static/media/henning.6d507298.png";